import { render, staticRenderFns } from "./typography-link-style.demo.vue?vue&type=template&id=78818552&scoped=true&"
import script from "./typography-link-style.demo.vue?vue&type=script&lang=js&"
export * from "./typography-link-style.demo.vue?vue&type=script&lang=js&"
import style0 from "./typography-link-style.demo.vue?vue&type=style&index=0&id=78818552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78818552",
  null
  
)

export default component.exports